import { BLACKLIST_GET_START, BLACKLIST_GET_DATA, BLACKLIST_GET_END, BLACKLIST_DELETE } from '../../slices/type';

interface InitState {
  data: any[];
  totalDocuments: number;
  loading: boolean;
  error: any;
}

const initState: InitState = { data: [], totalDocuments: 0, loading: false, error: null };

const Blacklist_Red = (state = initState, action: { type: string; payload?: any }): InitState => {
  switch (action.type) {
    case BLACKLIST_GET_START:
      return { ...state, loading: true };
    case BLACKLIST_GET_DATA:
      return { ...state, data: action.payload?.data ?? [], totalDocuments: action.payload?.totalDocuments ?? 0, loading: false };
    case BLACKLIST_DELETE:
      return { ...state, loading: false };
    case BLACKLIST_GET_END:
      return { ...state, error: action.payload, loading: false };
    default:
      return state;
  }
};

export default Blacklist_Red;
